import React from "react";
import { Link } from "react-router-dom";

import "Assets/css/mntn.css";
interface ChildComponentProps{
    noDataDesc: string
   }
const NoDataUi = ({noDataDesc}:ChildComponentProps) => {

    return(
        <>
        <div className="mntnWrap">
            <p className="mntnTime">{noDataDesc}</p>
        </div>
        </>
    )
}

export default NoDataUi;